import { createIconModule, FluentIconStyleProvider } from 'owa-fluent-icons-svg';
import CheckmarkFilled from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import CheckboxUncheckedRegular from 'owa-fluent-icons-svg/lib/icons/CheckboxUncheckedRegular';
import CheckboxCheckedFilled from 'owa-fluent-icons-svg/lib/icons/CheckboxCheckedFilled';
import { TagDuoToneIcon } from './TagDuoToneIcon';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon } from '@fluentui/react/lib/Icon';
import { getPalette } from 'owa-theme';

const rootStyle = {
    width: '1em',
    height: '1em',
    display: 'inline-flex',
};
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getPalette called at module scope is not allowed. This may cause unwanted side effects. */
const checkmarkFilledIconStyle = { color: getPalette().neutralPrimary, marginRight: '4px' };

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getPalette called at module scope is not allowed. This may cause unwanted side effects. */
const checkboxIconStyle = { color: getPalette().themePrimary, marginRight: '4px' };

function TagDuoToneBundle() {
    return (
        <FluentIconStyleProvider rootStyle={rootStyle}>
            <Icon iconName={CheckmarkFilled} style={checkmarkFilledIconStyle} />
            <Icon iconName={TagDuoToneIcon} />
        </FluentIconStyleProvider>
    );
}

function TagDuoToneCheckboxBundle() {
    return (
        <FluentIconStyleProvider rootStyle={rootStyle}>
            <Icon iconName={CheckboxUncheckedRegular} style={checkboxIconStyle} />
            <Icon iconName={TagDuoToneIcon} />
        </FluentIconStyleProvider>
    );
}

function TagDuoToneCheckboxFilledBundle() {
    return (
        <FluentIconStyleProvider rootStyle={rootStyle}>
            <Icon iconName={CheckboxCheckedFilled} style={checkboxIconStyle} />
            <Icon iconName={TagDuoToneIcon} />
        </FluentIconStyleProvider>
    );
}

const defaultExport: 'TagDuoToneChecked' = createIconModule('TagDuoToneChecked', TagDuoToneBundle);
export default defaultExport;

export const TagDuoToneCheckbox: 'TagDuoToneCheckbox' = createIconModule(
    'TagDuoToneCheckbox',
    TagDuoToneCheckboxBundle
);

export const TagDuoToneCheckboxFilled: 'TagDuoToneCheckboxFilled' = createIconModule(
    'TagDuoToneCheckboxFilled',
    TagDuoToneCheckboxFilledBundle
);
